import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { TIERS } from "@/lib/tiers";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Plus, Edit, Trash2, Eye, Star } from "lucide-react";

export default function AdminPosts() {
  const [posts, setPosts] = useState([]);

  const load = async () => {
    try { const { data } = await api.get("/admin/posts"); setPosts(data.posts || []); }
    catch (e) { console.error("Failed to load posts:", e); toast.error("Failed to load posts"); }
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this post permanently?")) return;
    try { await api.delete(`/admin/posts/${id}`); toast.success("Deleted"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display text-xl font-bold text-white">Content Management</h2>
        <Link to="/admin/posts/new" data-testid="admin-new-post">
          <Button className="bg-rose-600 hover:bg-rose-500"><Plus className="w-4 h-4 mr-2" />New Post</Button>
        </Link>
      </div>
      <div className="glass rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-zinc-400 text-xs uppercase tracking-wider bg-black/40">
              <tr><th className="text-left p-3">Title</th><th className="text-left p-3">Slug</th><th className="text-left p-3">Access</th><th className="text-left p-3">Status</th><th className="text-left p-3">Featured</th><th className="text-left p-3">Updated</th><th className="text-left p-3">Actions</th></tr>
            </thead>
            <tbody>
              {posts.map((p) => (
                <tr key={p.id} className="border-t border-white/5" data-testid={`admin-post-row-${p.id}`}>
                  <td className="p-3 text-white font-semibold">{p.title}</td>
                  <td className="p-3 text-zinc-400 font-mono text-xs">{p.slug}</td>
                  <td className="p-3"><Badge className={TIERS[p.access_level]?.chip}>{TIERS[p.access_level]?.label || p.access_level}</Badge></td>
                  <td className="p-3"><Badge className={p.status === "published" ? "bg-emerald-900/40 text-emerald-300 border border-emerald-500/30" : "bg-amber-900/40 text-amber-300 border border-amber-500/30"}>{p.status}</Badge></td>
                  <td className="p-3">{p.featured ? <Star className="w-4 h-4 text-rose-400 fill-rose-400" /> : <span className="text-zinc-600">—</span>}</td>
                  <td className="p-3 text-zinc-400 text-xs">{new Date(p.updated_at || p.created_at).toLocaleDateString()}</td>
                  <td className="p-3">
                    <div className="flex gap-1.5">
                      <Link to={`/posts/${p.slug}`}><Button size="sm" variant="outline" data-testid={`view-post-${p.id}`}><Eye className="w-3 h-3" /></Button></Link>
                      <Link to={`/admin/posts/${p.id}/edit`}><Button size="sm" variant="outline" data-testid={`edit-post-${p.id}`}><Edit className="w-3 h-3" /></Button></Link>
                      <Button size="sm" variant="outline" onClick={() => del(p.id)} className="border-rose-500/40 text-rose-300" data-testid={`delete-post-${p.id}`}><Trash2 className="w-3 h-3" /></Button>
                    </div>
                  </td>
                </tr>
              ))}
              {posts.length === 0 && <tr><td colSpan={7} className="text-center p-8 text-zinc-500">No posts yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
